const adjustMenuPosition = (anchor, content) => {
  const viewportHeight = window.innerHeight
  const viewportWidth = window.innerWidth
  const buttonRect = anchor.getBoundingClientRect()
  const menuRect = content.getBoundingClientRect()
  // check if the menu is going to be out of the viewport on the left
  if (buttonRect.left - menuRect.width < 0) {
    content.style.left = '0'
    content.style.right = 'auto'
  } else {
    content.style.left = 'auto'
    content.style.right = '0'
  }
  // check if the menu is going to be out of the viewport on the right
  if (buttonRect.right + menuRect.width > viewportWidth) {
    content.style.right = '0'
    content.style.left = 'auto'
  } else {
    content.style.right = 'auto'
    content.style.left = '0'
  }

  // check if the menu is going to be out of the viewport on the top and bottom
  if (buttonRect.bottom + content.offsetHeight > viewportHeight) {
    content.style.bottom = `${buttonRect.height + 10}px`
    content.style.top = 'auto'
  } else {
    content.style.bottom = 'auto'
    content.style.top = `${buttonRect.height}px`
  }
}

export const initDropdown = dropdownId => {
  if (!dropdownId) {
    console.error('No dropdown ID provided, please add an ID to the dropdown init func.')

    return
  }

  const button = document.getElementById(dropdownId)
  if (button === null) {
    // console.error('No dropdown ID provided, please add an ID to the dropdown element.')

    return
  }

  const menu = document.getElementById(`dropdownMenu-${dropdownId}`)

  button.addEventListener('click', () => {
    adjustMenuPosition(button, menu)

    menu.classList.toggle('invisible')
    menu.classList.toggle('visible')
    menu.classList.toggle('opacity-0')
    menu.classList.toggle('scale-y-0')
    menu.classList.toggle('scale-y-100')
    const isOpen = !menu.classList.contains('invisible')

    button.querySelector('span.arrow>svg.lucide').style.transform = isOpen ? 'rotate(-180deg)' : 'rotate(0deg)'
  })

  document.addEventListener('click', event => {
    if (!button.contains(event.target) && !menu.contains(event.target)) {
      if (menu.classList.contains('invisible')) {
        return
      }

      menu.classList.add('invisible')
      menu.classList.remove('visible')

      menu.classList.add('opacity-0')
      menu.classList.remove('scale-y-100')
      menu.classList.add('scale-y-0')

      button.querySelector('span>svg.lucide').style.transform = 'rotate(0deg)'
    }
  })
}

document.addEventListener('DOMContentLoaded', () => {
  /* Add all dropdown ids */
  const dropdownIds = [
    'langDropdown',
    'themeDropdown',
    'loginDropdown',
    'langDropdownFooter',
    'langDropdownHeader',
    'langDropdownHeader2',
    'langDropdownMenu',
    'more'
  ]

  dropdownIds.forEach(id => initDropdown(id))
})
